import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=4adbb51c&scoped=true&"
import script from "./Occupation.vue?vue&type=script&lang=js&"
export * from "./Occupation.vue?vue&type=script&lang=js&"
import style0 from "./Occupation.vue?vue&type=style&index=0&id=4adbb51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adbb51c",
  null
  
)

export default component.exports